import { Cards } from "components/Base";
import FieldCard from "./FieldCard";

export default Cards(FieldCard);
